import { jsx as i } from "react/jsx-runtime";
import { Icon as h } from "../../../../components/Icon/index.js";
import { ToolbarButton as d } from "../../styles.js";
import { useQuillLoading as k } from "../LoadingEditor/index.js";
import { useTranslation as x } from "../../../../hooks/useTranslation/index.js";
import { Image as C } from "@pelando/fontawesome/icons";
function w({
  quill: t,
  uploadHandler: r,
  onUploadError: n,
  hidden: s = !1
}) {
  const { startLoading: g, stopLoading: f } = k(), { t: o } = x("common");
  return !s && /* @__PURE__ */ i(
    d,
    {
      type: "button",
      onClick: () => {
        const e = document.createElement("input");
        e.type = "file", e.accept = "image/png, image/jpeg", e.onchange = () => {
          var a;
          const c = (a = e == null ? void 0 : e.files) == null ? void 0 : a[0];
          c && (g(), r(c).then((p) => {
            const b = (t == null ? void 0 : t.getText()) || "";
            t == null || t.setSelection(b.length, 0);
            const m = t == null ? void 0 : t.getSelection();
            t == null || t.insertEmbed((m == null ? void 0 : m.index) || 0, "image", p), f();
          }).catch(() => {
            n == null || n(new Error(o("comment-image-button-error")));
          }));
        }, e.click();
      },
      title: o("comment-image-button-title"),
      children: /* @__PURE__ */ i(h, { icon: C, "aria-label": o("comment-image-button-title") })
    }
  );
}
export {
  w as ImageButton
};
